import React from 'react';

import { Input } from '@interlayer/js/components/common/Fields/Input/Input';

import { useTranslations } from '@core/js/hooks/i18n';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

import { TInputRegProps } from './types';

export const InputReg: React.FC<TInputRegProps> = ({
    name,
    type = 'text',
    placeholder,
    className,
    classNames = {},
    labelKey = name,
    inputMode = 'text',
    autoComplete,
    autoCapitalize,
    isDisabledCopyPast,
    isOnlyNumber,
    pattern,
    validate,
    onFocus,
    onBlur,
    onChange
}) => {
    const t = useTranslations('playtech.mobile.system.registration.label.');
    const { config: { showSuccessTickIcons } } = useRegistrationSelector();

    return (
        <Input
            name={name}
            type={type}
            pattern={pattern}
            inputMode={inputMode}
            className={className}
            classNames={classNames}
            isOnlyNumber={isOnlyNumber}
            autoComplete={autoComplete}
            autoCapitalize={autoCapitalize}
            placeholder={placeholder || t(labelKey)}
            isDisabledCopyPast={isDisabledCopyPast}
            isShowValidationIcon={showSuccessTickIcons}
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onChange}
            validate={validate}
        />
    );
};
